module.exports = __webpack_public_path__ + "img/img3.999f1c34.png";